<template>
  <ShBlade
    invert="true"
    :visible="visible"
    @update:visible="closeHouseBoard"
  >
    <template #header>
      <div class="board-header">
        <UserGreeting :firstName="profile.firstName" class="user-greeting" />
        <ShIcon
          class="board-close-icon"
          name="close"
          size="xsmall"
          :invert="true"
          @click="closeHouseBoard"
        />
      </div>
    </template>
    <div
      class="board-wrapper"
      v-click-outside="closeHouseBoard"
    >
      <component
        v-bind:is="activeComponent"
        @handleViewChange="handleViewChange"
      />
    </div>
  </ShBlade>
</template>

<script>

import { createNamespacedHelpers } from 'vuex'
import { ShBlade, ShIcon } from '@sohohouse/design-system'

import UIMixin from '~/mixins/ui'
import UserGreeting from '~/components/user-greeting'
import { VIEWS } from '~/constants/house-board-views'

import DefaultView from './default'
import NotificationView from './notifications'

const { mapActions: mapModalActions, mapGetters: mapModalGetters } = createNamespacedHelpers('ui/modals')
const { mapGetters: mapProfileGetters } = createNamespacedHelpers('user/profile')

export default {
  components: {
    UserGreeting,
    ShBlade,
    DefaultView,
    NotificationView,
    ShIcon
  },

  mixins: [
    UIMixin
  ],

  data () {
    return {
      VIEWS,
      name: 'house-board',
      activeComponent: VIEWS.HOUSE_BOARD
    }
  },

  computed: {
    ...mapModalGetters(['openModals']),
    ...mapProfileGetters(['profile']),

    visible () {
      return this.openModals.includes(this.name)
    }
  },

  watch: {
    '$route.path': 'closeHouseBoard'
  },

  methods: {
    ...mapModalActions(['close']),

    closeHouseBoard () {
      this.$ui.modal.close(this.name)
      this.handleViewChange(VIEWS.HOUSE_BOARD)
    },

    handleViewChange (value) {
      this.activeComponent = value
    }
  }
}
</script>

<style lang="scss" scoped>

.board-header {
  display: flex;
  justify-content: space-between;
  padding: $space-050;

  @include tablet {
    padding: $space-060;
  }
}

.board-close-icon {
  filter: invert(1);
}

.board-wrapper {
  height:  100%;
  padding: $space-050 $space-050 0 $space-050;

  @include tablet {
    padding: $space-050 $space-060 0 $space-060;
  }
}

.default-view {
  margin: $space-070 0;
}

</style>
